<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15rvhmM/tc-custom/9781466815339.jpg?1719574868939" alt="This image is the cover for the book All That I Need, The Grayson Friends Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">All That I Need, The Grayson Friends Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>A committed bachelor and a career woman meet by chance and fall in love in this African American romance from a <i>New York Times</i>–bestselling author.</b><br/><br/><i>Love comes with no guarantee . . .</i><br/><br/>Lance Saxton is a self-made man who enjoys every moment of his success. Running an auction house allows him to manage his own time and travel the world on a moment’s notice—so why rush to settle down? The question answers itself . . . until he crosses paths with a beautiful, spirited travel writer who makes him second-guess his sense of independence—and leaves him wanting more.<br/><br/><i>But it’s always worth the risk . . .</i><br/><br/>What’s love got to do with it? Fallon Marshall is at the peak of her career as a journalist. Any story she wants she can get. So when she hears about an auction being held at a fabled old estate in Santa Fe, New Mexico, off she goes . . . only to meet a man who makes her question her priorities. Maybe it’s time for Fallon to stop running away in search of adventure . . . and just fall into Lance’s arms?<br/><br/><b>Praise for Francis Ray</b><br/><br/>“The Grayson Friends series [is] told with such grace and affection . . . a treat to read.” —<i>RT Book Reviews</i><br/><br/>“[A] graceful writing style and realistically complex characters.” —<i>Chicago Tribune</i><br/><br/>“Francis Ray is, without a doubt, one of the Queens of Romance.” —<i>A Romance Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francis Ray
      </h2>
      
      <p class="authorDescription body article"><B>Francis Ray</B> is the <I>New York Times</I> bestselling author of the Grayson novels, the Falcon books, the Taggart Brothers, and <I>Twice the Temptation</I>, among many other books. Her novel <I>Incognito</I> was made into a movie aired on BET. A native Texan, she is a graduate of Texas Woman's University and has a degree in nursing. Besides a writer, she is a school nurse practitioner with the Dallas Independent School District. She lives in Dallas. "Francis Ray is, without a doubt, one of the Queens of Romance." --<I>Romance Review</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b5e5b250